module.exports = __webpack_public_path__ + "static/img/5.6dc4b991.png";